import Vue from 'vue'
import Vuex from 'vuex'

import animations from './animations'
import articles from './articles'
import certificates from './certificates'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    footerInViewport: false
  },
  getters: {
    footerState: state => state.footerInViewport
  },
  mutations: {
    updateFooterStatus (state, status) {
      state.footerInViewport = status
    }
  },
  modules: {
    animations,
    articles,
    certificates
  }
})
